import { createAction, props } from '@ngrx/store';
import { DataModuleEntity, DataModuleEntityId } from '@edgvr-front/data/domain';

export const start = createAction('[Data Module / Module Page] Start');
export const stop = createAction('[Data Module / Module Page] Stop');

export const reset = createAction('[Data Module / Module Page] Reset');

export const selectedDataModuleSet = createAction(
  '[Data Module / Module Page] Selected Data Module Set',
  props<{ id: DataModuleEntityId }>()
);

export const dataModuleGet = createAction(
  '[Data Module / Module Page] Data Module Get',
  props<{ id: DataModuleEntityId }>()
);
export const dataModuleGetSuccess = createAction(
  '[Data Module / Module Page] Data Module Get Success',
  props<{ dataModule: DataModuleEntity }>()
);
export const dataModuleGetFailure = createAction(
  '[Data Module / Module Page] Data Module Get Failure'
);
